import { ISeoFilterState, ISeoInfoBase } from '@studyportals/fawkes/programmes-search-seo';
import { FilterKey } from '@studyportals/search-filters';

export class SeoInfoBase implements ISeoInfoBase {
	public selectionOnlyFor(keys: FilterKey[], filterSelectionState: ISeoFilterState): Promise<boolean> {
		const selected = filterSelectionState.getSelectedFilters();

		const allKeysIncluded = keys.every((key) => selected.includes(key));
		return Promise.resolve(selected.length === keys.length && allKeysIncluded);
	}

	public singleSelectionFor(filterKey: FilterKey, filterSelectionState: ISeoFilterState): Promise<boolean> {
		return Promise.resolve(filterSelectionState.getSelectedValuesFor(filterKey).length === 1);
	}

	public getFilterOptionValueBy(filterKey: FilterKey, filterSelectionState: ISeoFilterState): string | null {
		const filterSelection = filterSelectionState.getSelectedValuesFor(filterKey);
		if (filterSelection.length === 0) {
			return null;
		}

		return filterSelection[0];
	}

	public getSelectionTypeCount(filterSelectionState: ISeoFilterState): number {
		return filterSelectionState.getSelectedFilters().length;
	}
}
